import {TZ_DEFAULT, yyyymmdd} from "../../../../services/Dates";


//changes requested in US629564
export const firstAvailableBrokerageActivityDate = new Date(2019, 0, 1);

export const formattedFirstAvailableBrokerageActivityDate = yyyymmdd(firstAvailableBrokerageActivityDate, TZ_DEFAULT);
